import { Timestamp } from "firebase/firestore";

// Re-export the existing type for compatibility
export type { EachWhatsNewContent as WhatsNewArticle } from "../../../app/growth-block/type";

// Validation constants for What's New feature
export const WHATS_NEW_VALIDATION = {
  BUTTON_TEXT_MAX_LENGTH: 18,
  IMAGE_RATIO: {
    WIDTH: 1920,
    HEIGHT: 1047,
    DISPLAY: "1920 x 1047",
  },
  MANIFEST_DEFAULT_PATH: "/home",
} as const;

export interface FilterState {
  searchQuery: string;
  selectedModuleFilter: string[];
  selectedUpdateTypeFilter: string;
  selectedDateFilter: string;
  selectedStatusFilter: string;
  customStartDate: string;
  customEndDate: string;
}

export interface ModalState {
  isFilterModalOpen: boolean;
  showDatePicker: boolean;
  videoModalOpen: boolean;
  currentVideoUrl: string;
}

export interface EditingState {
  openModal: boolean;
  itemSelectedForEditing?: import("../../../app/growth-block/type").EachWhatsNewContent;
  indexToUpdate?: string;
  operationType: "add" | "edit";
}

export interface TableColumn {
  key: string;
  label: string;
  width?: string;
}

export type FilterType = "module" | "updateType" | "date" | "status";

export interface FilterOption {
  label: string;
  value: string;
  isActive: boolean;
}
